var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.28,
    height: 20,
    viewBox: "0 0 26.28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-envelope",
    "data-name": "001-envelope",
    transform: "translate(0 -57.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 57.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M23.072,57.75H3.214A3.216,3.216,0,0,0,0,60.964V74.536A3.216,3.216,0,0,0,3.214,77.75H23.067a3.216,3.216,0,0,0,3.214-3.214V60.969A3.213,3.213,0,0,0,23.072,57.75Zm1.746,16.786a1.747,1.747,0,0,1-1.746,1.746H3.214a1.747,1.747,0,0,1-1.746-1.746V60.969a1.747,1.747,0,0,1,1.746-1.746H23.067a1.747,1.747,0,0,1,1.746,1.746V74.536Z",
    transform: "translate(0 -57.75)",
    fill: "#2f4491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M69.295,115.952l6.427-5.764a.735.735,0,1,0-.984-1.093l-8.864,7.955-1.729-1.544c-.005-.005-.011-.011-.011-.016a1.086,1.086,0,0,0-.12-.1l-7.036-6.3a.736.736,0,1,0-.979,1.1L62.5,116l-6.476,6.063a.737.737,0,0,0-.033,1.039.751.751,0,0,0,.538.234.736.736,0,0,0,.5-.2l6.574-6.15,1.784,1.593a.732.732,0,0,0,.979-.005l1.833-1.642,6.536,6.21a.736.736,0,0,0,1.039-.027.737.737,0,0,0-.027-1.039Z",
    transform: "translate(-52.721 -106.121)",
    fill: "#2f4491"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmail);
export default __webpack_public_path__ + "static/media/icn-email.4227b9b3.svg";
export { ForwardRef as ReactComponent };